import templateUrl from 'emun.on-demand/designer-container.htm'
import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'


class DesignerContainerController {
    constructor() {
        basicController(this)
        const $ctrl = this;
    }
    $onInit() {
        const $ctrl = this;
    }
}

let DesignerContainerComponent = {
    bindings: {
        onSaved: '&'
    },
    controller: DesignerContainerController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default DesignerContainerComponent;